import { useDocumentTitleReset } from '../../hooks/useDocumentTitle';

const DocumentTitleReset: React.FC = () => {
  useDocumentTitleReset();
  return null;
};

export default DocumentTitleReset;
